import { cloneElement, type ReactElement } from "react";

export type SpaceIconSize = "xs" | "sm" | "md" | "lg";

const SIZE_PX: Record<SpaceIconSize, number> = { xs: 16, sm: 22, md: 28, lg: 40 };
// Each gap (SIZE_PX - ICON_PX) is kept even so centering always lands on a whole pixel;
// an odd gap (e.g. 16-9=7) can't split evenly and the browser's rounding reads as off-center.
const ICON_PX: Record<SpaceIconSize, number> = { xs: 8, sm: 12, md: 14, lg: 20 };

export interface SpaceIconProps {
  icon: ReactElement<{ size?: number }>;

  hue: number;

  size?: SpaceIconSize;
}

export function SpaceIcon({ icon, hue, size = "md" }: Readonly<SpaceIconProps>) {
  return (
    <span
      className="sp-chip grid shrink-0 place-items-center rounded-lg"
      style={{ "--sp-h": hue, width: SIZE_PX[size], height: SIZE_PX[size] } as React.CSSProperties}
    >
      {cloneElement(icon, { size: ICON_PX[size] })}
    </span>
  );
}
